import { render, staticRenderFns } from "./NotificationbarItem.vue?vue&type=template&id=f979a9c2&"
import script from "./NotificationbarItem.vue?vue&type=script&lang=js&"
export * from "./NotificationbarItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationbarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports